import styled from '@emotion/styled';
import { COLORS } from "../../constants/Theme";
import { getTheme } from './themes';
export const ListItem = styled.div `
	border-bottom: ${(props) => props.borderBottom ||
    `${props.version === '2.0' ? 0 : 1}px solid ${COLORS.stroke.primary}`};
	display: flex;
	align-items: center;
	justify-content: start;
	column-gap: 12px;
	padding: ${(props) => (props.version === '2.0' ? '8px 12px' : '12px 16px')};
	${(props) => getTheme(props.variant, props.version)};
	border-radius: ${(props) => (props.version === '2.0' ? 8 : 0)}px;
`;
//# sourceMappingURL=ListItem.styled.js.map